import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const BeritaAcaraPemusnahanPage = lazy(() => import('./pages/berita-acara-pemusnahan'))
const LaporBarangNgPage = lazy(() => import('./pages/lapor-barang-ng'))

/** Cluster C12 Pemusnahan RM — DSR-02 (daftar + detail `:id`), DSR-05 (Lapor Barang NG, mobile). */
const destructionRmRoutes: RouteObject[] = [
  {
    path: 'destruction-rm',
    children: [
      {
        path: 'berita-acara-pemusnahan',
        children: [
          { index: true, element: <BeritaAcaraPemusnahanPage /> },
          { path: ':id', element: <BeritaAcaraPemusnahanPage /> }
        ]
      },
      { path: 'lapor-barang-ng', element: <LaporBarangNgPage /> }
    ]
  }
]

export default destructionRmRoutes
